import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { InboxOrderUpdateInput } from '@libs/types/src/inbox/input-type/inbox-order.update-input';
import { OkObject } from '@it2go/types';

@Injectable({ providedIn: 'root' })
export class InboxOrderGqlService extends GqlServiceV2 {

    updateInboxOrder(input: InboxOrderUpdateInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxOrderUpdateInput!) {
                inboxOrder {
                    update(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }
}
